module.exports = __webpack_public_path__ + "img/knowhow-1.266226b.webp";